<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_okr_on.png" alt="">
            <span v-if="this.$route.params.item">{{$t('keyResultEditType')}}</span>
            <span v-else>{{$t('keyResultRegisType')}}</span>
          </h1>
          <div class="wrapper" v-if="isProxy">
            <span class="info-userimg">
              <img v-if="getUserInfoById(uid).userIcon" class="img-circle" :src="getUserInfoById(uid).userIcon"  :alt='getUserInfoById(uid).userName'>
              <img v-else class="img-circle" :src="'static/img/noImage.png'"  :alt='getUserInfoById(uid).userName'>
            </span>
            <span class="info-username">{{ getUserInfoById(uid).userName }}</span>
            <span>{{ getUserInfoById(uid).dept }}</span>
          </div>
          <span class="info-right">
          </span>
        </div>
        <div v-if="isLiteMode">
          <b-alert variant="danger" show>{{$t('liteIsStr')}}</b-alert>
        </div>
        <div v-else>
        <!-- /ViewTitleBox -->
          <section class="animated fadeInRight">
            <div class="ibox">
              <form  @submit.prevent class="ibox-content" action="okr/list">
                <div class="ibox-child">
                  <div class="row">
                    <div class="form-group col-sm-12">
                      <label class="control-label">{{$t('keyResultDetailType')}}</label>
                      <textarea class="form-control" :placeholder="$t('inputKeyResultGoalStr')" rows="7" v-model="keyresultInfo.contentText"></textarea>
                      <span v-if="!$v.keyresultInfo.contentText.contentTextValidaiton" class="text-danger font-bold">{{$t('alertRequiredItemStr')}}</span>
                    </div>
                  </div>
                </div>
                <regist-limit :view="view" :dueDate="this.dueDate" :startDate="this.startDate" :progress="getRate" :alertDate="this.$v.dueDate.dueDateValidation" v-on:set-progress="updateProgressInfo"/>
                <regist-share :checkedUsers="this.checkedShareUsers" :okrType="'keyResult'"/>
                <regist-public @delete-public-user="deletePublicUser" @delete-public-group="deletePublicGroup" @delete-public-org="deletePublicOrg" @reset-public="resetSelectPublic" @open-public="setDetail" :checkedUsers="this.checkedPublicUsers" :checkedGroups="this.checkedPublicGroups" :checkedOrgs="this.checkedPublicOrgs"/>
                <regist-relation @openRelation="setDetail" :checkedObjectives="this.checkedObjectives" v-on:delete-relation="deleteRelation"/>
                <div class="ibox-child">
                  <div class="row okr-regist-btnset" v-if="isProxy">
                    <div class="col-lg-6 col-md-6 col-sm-6"><button @click="newKeyresult" id="okr-save" type="button" class="btn btn-success block m-b" :disabled="checkRegistering">{{$t('saveStr')}}</button></div>
                    <div class="col-lg-6 col-md-6 col-sm-6"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
                  </div>
                  <div class="row okr-regist-btnset" v-else>
                    <div class="col-lg-4 col-md-4 col-sm-4"><button @click="newKeyresult" id="okr-save" type="button" class="btn btn-success block m-b" :disabled="checkRegistering">{{$t('saveStr')}}</button></div>
                    <div class="col-lg-4 col-md-4 col-sm-4"><button @click="cancelKeyresult" type="button" class="btn btn-primary block m-b" :disabled="checkRegistering">{{$t('popTitleStr2Type')}}</button></div>
                    <div class="col-lg-4 col-md-4 col-sm-4"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
                  </div>
                </div>
              </form>
            </div>
          </section>
        </div>
      </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
            <div class="ibox-title flex-box fl-between ibox-detail-header">
              <span class="info-menu flex-box">
                <template v-if="detail == 'public'">{{$t('publicSettingLabelTitle')}}</template>
                <template v-if="detail == 'relation'">{{$t('relatedOkrType')}}</template>
              </span>
              <span class="info-right"></span>
            </div>
            <!-- Public -->
            <public-setting-detail-view v-if="detail == 'public'"
              :checkedOrgs="checkedPublicOrgs"
              :checkedGroups="checkedPublicGroups"
              :checkedUsers="checkedPublicUsers"
              :uid="uid"
              @updateGroups="onClickGroups"
              @updateOrganization="onClickOrg"
              @updateUsers="onClickUsers"
              ref="publicSetting"/>
          <!-- /Public  -->

            <!-- RelationObject -->
            <div v-else-if="detail == 'relation'" class="ibox">
                <div class="ib-sub-content">
                    <!-- ユーザー検索ボックス -->
                    <div class="ibox-title search-box">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="input-group">
                                    <input type="text" v-model="searchText" class="typeahead_2 form-control" :placeholder="$t('searchWithUserName')">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ibox-content search-resultview">
                        <ul v-if="searchText == ''">
                            <li v-if="getVisitedUsers.length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                            <li><label>{{$t('checkUserStrType')}}</label></li>
                              <div v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo">
                              <li @click="onClickUser(user.userId, user)">
                                  <span class="search-userimg">
                                    <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                  </span>
                                  <div class="search-userinfo">
                                    <span class="search-username">{{ user.userInfo.userName }}</span>
                                    <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                  </div>
                                  <span class="check-mark"></span>
                              </li>
                            </div>
                        </ul>
                        <ul v-else>
                          <li v-if="Object.keys(this.getUsersBySearchText).length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                          <div v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo">
                            <li @click="onClickUser(key, user)">
                                <span class="search-userimg">
                                  <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                  <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                </span>
                                <div class="search-userinfo">
                                  <span class="search-username">{{ user.userInfo.userName }}</span>
                                  <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                </div>
                            </li>
                          </div>
                          </ul>
                          <div>
                            <transition name="fade">
                              <div v-if="showModal" class="modal-mask">
                                <div class="modal-wrapper">
                                  <div class="modal-container">
                                    <div class="modal-header">
                                      <slot name="header">
                                        <span class="search-userimg">
                                          <img v-if="targetUser.userInfo.userIcon" :src="targetUser.userInfo.userIcon" alt="image" class="img-circle">
                                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                        </span>
                                        <div class="search-userinfo">
                                          <span class="search-username">{{ this.targetUser.userInfo.userName }}</span>
                                          <span class="search-userdept">{{ this.targetUser.userInfo.dept }}</span>
                                        </div>
                                      </slot>
                                    </div>
                                    <div class="modal-body">
                                      <div class="m-body-wrap">
                                        <slot name="body">
                                          <div v-for="(item, index) in getRelationObjectives" :key="index" v-if="checkRelationsFillter(item.obj, item.key)" :class="{'comp-mark' : getIsComp(item.obj)}" class="ibox">
                                            <div :class="{'added' : !isShowObjectives(item.key)}" class="ibox-title">
                                              <label>
                                                <input type="checkbox" v-model="preCheckedObjs" :value="{userId: targetUserId, targetId: item.key, type: 'objectives'}" class="checkbox relation-check">
                                                <span class="check-mark"></span>
                                                <objective :addMore = "true" :itemId ="item.key" :content="item.obj.contentText" :progress="item.obj.progress ? item.obj.progress : '0'" :setReadOnly="'false'" :objective="true" />
                                                <span class="due-date due-date-color">{{$t('dueDateStr')}} : {{item.obj.dueDate}}</span>
                                                <div class="ibox-tools">
                                                  <span @click.stop.prevent="setKeyresultOpen(item.key)" class="info-menu cursor">
                                                    <button class="btn btn-secondary">
                                                      <i :class="{'chevronUp' : !getIsOpen(item.key)}" class="fa fa-chevron-down"></i>
                                                      <span v-if="!getIsOpen(item.key)">{{$t('indicateItemClose')}}</span>
                                                      <span v-else>{{$t('indicateAllNotice')}}</span>
                                                    </button>
                                                  </span>
                                                  <span class="info-right">
                                                    <span class="info-comment-detail">
                                                      <img src="static/img/assets/comment.png">
                                                      <span>{{getCommentsByItemId(item.key, targetType).length}}</span>
                                                  </span>
                                                    <span class="info-comment-detail">{{$t('createDateString')}} : {{item.obj.createdAt | preparedTime}}</span>
                                                  </span>
                                                </div>
                                            </label>
                                          </div>
                                          <div :class="{'keyResultClose' : getIsOpen(item.key)}" class="ibox-content key-indent">
                                              <!-- ボックス -->
                                              <!-- KeyResult1 -->
                                              <div v-for="(keyresult, keyresultId) in getTargetKeyresults(item.key)" :key="keyresultId" v-if="checkRelationsFillter(keyresult, keyresultId)" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult), 'added' : !isShowObjectives(keyresultId)}">
                                                <div><label>
                                                  <input type="checkbox" v-model="preCheckedObjs" :value="{userId: targetUserId, targetId: keyresultId, type: 'keyresults'}" class="checkbox relation-check">
                                                  <span class="check-mark"></span>
                                                  <div>
                                                    <span class="comp"></span>
                                                    <objective :addMore="true" :itemId ="keyresultId" :content="keyresult.contentText" :progress="keyresult.progress ? keyresult.progress : '0'" :setReadOnly="'false'"  :objective="false" />
                                                  </div>
                                                  <span class="due-date due-date-color">{{$t('dueDateStr')}} : {{keyresult.dueDate}}</span>
                                                  <div class="ibox-tools">
                                                    <span class="info-menu"></span>
                                                    <span class="info-right">
                                                      <span class="info-comment-detail">
                                                        <img src="static/img/assets/comment.png"><span>{{getCommentsByItemId(keyresultId,'keyresults').length}}</span>
                                                      </span>
                                                      <span class="info-comment-detail">{{$t('createDateString')}} : {{keyresult.createdAt|  preparedTime}}</span>
                                                    </span>
                                                  </div>
                                                </label></div>
                                              </div>
                                              <!-- /KeyResult1  -->
                                            <!-- /ボックス -->
                                          </div>
                                          </div>
                                        </slot>
                                      </div>
                                    </div>
                                    <div class="modal-footer">
                                      <slot name="footer">
                                        <div class="row okr-regist-btnset">
                                          <div class="col-lg-4 col-md-4 col-sm-4 col-sm-offset-2"><button @click="onClickModalOk" type="button" class="modal-default-button btn btn-success">{{ $t('modalOkStr') }}</button></div>
                                          <div class="col-lg-4 col-md-4 col-sm-4"><button @click="closeModal" type="button" class="modal-default-button btn btn-danger">{{ $t('cancelStr') }}</button></div>
                                        </div>
                                      </slot>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </transition>

                          </div>
                    </div>
                    <!-- /ユーザー検索ボックス -->
                </div>
              </div>
              <!-- /RelationObject  -->
            </div>
          </section>
        </article>
      </div>

    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import RegistLimit from '@/components/Regist/RegistLimit'
import RegistPublic from '@/components/Regist/RegistPublic'
import RegistRelation from '@/components/Regist/RegistRelation'
import RegistShare from '@/components/Regist/RegistShare'
import Objective from '@/components/Okr/Objective'
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import OrganizationItem from '@/components/People/OrganizationItem'
import { liteMode } from '@/main.js'
import PublicSettingDetailView from '@/components/DetailView/PublicSettingDetailView'

function contentTextValidaiton () {
  return this.keyresultInfo.contentText.trim().replace(/\r?\n/g, '').length !== 0
}

function dueDateValidation () {
  return this.dueDate >= this.startDate
}

export default {
  name: 'KeyresultRegist',
  mixedins: [validationMixin],
  components: {
    RegistLimit,
    RegistPublic,
    RegistRelation,
    Objective,
    OrganizationItem,
    PublicSettingDetailView,
    RegistShare
  },
  data: function () {
    return {
      isLiteMode: liteMode,
      tag: 'regist',
      view: 'Okr',
      open: false,
      detail: '',
      showModal: false,
      dueDate: new Date(),
      startDate: new Date(),
      progress: '0',
      progressMax: 100,
      progressMin: 0,
      searchText: '',
      groups: {},
      targetType: 'keyresults',
      checkedPublicGroups: [],
      checkedPublicUsers: [],
      checkedPublicOrgs: [],
      checkedShareUsers: [],
      preCheckedObjs: [],
      checkedObjectives: [],
      oldRelationInfos: [],
      targetUserId: '',
      targetUser: '',
      parentObjId: '',
      keyresultOpen: {},
      keyresultInfo: {
        contentText: '',
        dueDate: '',
        startDate: '',
        progress: '0',
        parentObjId: '',
        limitedAccess: {},
        relations: {},
        createdAt: new Date()
      },
      id: this.$route.params.id,
      isProxy: this.$route.params.isProxy,
      proxyUserId: this.$route.params.proxyUserId,
      checkDraft: false,
      isRegistering: false
    }
  },
  validations: {
    keyresultInfo: {
      contentText: {
        required,
        contentTextValidaiton
      }
    },
    dueDate: {
      dueDateValidation
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'KeyresultRegist'
    },
    checkRegistering () {
      return this.isRegistering
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('okrs/', [
      'getRelationInfo'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByUserId'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByParentObjId',
      'getCurrentDraftKeyresults',
      'getKeyresultsByUserId'
    ]),
    ...mapGetters('groups/', [
      'getCurrentGroupsByText',
      'getOnlyGroupsBySearchText',
      'getGroupsByText',
      'getGroupsByIds',
      'getCurrentGroups',
      'getGroups'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUsers',
      'getUserInfoById'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId'
    ]),
    ...mapGetters('organizations/', [
      'getOnlyOrganizationsByText',
      'getOpenOrganization',
      'getOrganizationExpansion',
      'getOrganizationRoots',
      'getOnlyOrganizationsByIds'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getGroupsBySearchText: function () {
      return this.getOnlyGroupsBySearchText(this.searchText)
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getUsers
      } else {
        return this.getUsersByText(this.searchText)
      }
    },
    getOrganizationsBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getGroups
      } else {
        return this.getOnlyOrganizationsByText(this.searchText)
      }
    },
    getRate: {
      get: function () {
        // return this.progress
        return this.progress ? this.progress : '0'
      },
      set: function (value) {
        this.progress = String(value)
      }
    },
    getRelationObjectives: function () {
      let relationOkrs = []
      if (this.targetUserId) {
        const relationOkrObj = this.getObjectivesByUserId(this.targetUserId)
        for (let key in relationOkrObj) {
          if (key === '.key') { continue }
          if (relationOkrObj[key] && relationOkrObj[key].contentText !== '') {
            if (!relationOkrObj[key].isComplete) {
              relationOkrs.push({key: key, obj: relationOkrObj[key]})
            } else if (relationOkrObj[key].isComplete === false) {
              relationOkrs.push({key: key, obj: relationOkrObj[key]})
            } else {
              continue
            }
          }
        }
        return relationOkrs.reverse()
      } else {
        return relationOkrs
      }
    },
    uid: function () {
      return this.proxyUserId || this.getUserId
    }
  },
  beforeMount: function () {
    this.groups = this.getGroups
    if (this.$route.params.item) {
      const dueDate = new Date(this.$route.params.item.dueDate)
      this.dueDate = dueDate
      if (this.$route.params.item.startDate) {
        const startDate = new Date(this.$route.params.item.startDate)
        this.startDate = startDate
      } else {
        this.startDate = null
      }
      if (this.$route.params.item.progress) {
        this.getRate = this.$route.params.item.progress
      } else {
        this.getRate = 0
      }
      // this.progress = this.$route.params.item.progress
    } else if (this.$route.params.parentObjId) {
      const parentObjective = this.getObjectivesByUserId(this.uid)[this.$route.params.parentObjId]
      if (parentObjective.startDate) {
        this.startDate = new Date(parentObjective.startDate)
      }
      if (parentObjective.dueDate) {
        this.dueDate = new Date(parentObjective.dueDate)
      }
    }
  },
  mounted: function () {
    if (this.isRegistering) {
      this.isRegistering = false
    }
    if (this.$route.params.parentObjId) {
      this.parentObjId = this.$route.params.parentObjId
      const parentObjective = this.getObjectivesByUserId(this.uid)[this.parentObjId]
      if (parentObjective.limitedAccess) {
        if (parentObjective.limitedAccess.limitedUsers) {
          this.checkedPublicUsers = Object.keys(parentObjective.limitedAccess.limitedUsers)
        }
        if (parentObjective.limitedAccess.limitedGroups) {
          let allGroups = this.getGroupsByIds(Object.keys(parentObjective.limitedAccess.limitedGroups))
          let groupIds = Object.keys(allGroups).filter(x => !allGroups[x].isOrganization)
          let orgIds = Object.keys(allGroups).filter(x => allGroups[x].isOrganization)
          this.checkedPublicGroups = groupIds
          this.checkedPublicOrgs = orgIds
        }
      }
      if (parentObjective.hasOwnProperty('sharedOwners')) {
        this.checkedShareUsers = Object.keys(parentObjective.sharedOwners).filter(userId => userId !== this.uid)
      }
      console.log('parentObj Id::', this.parentObjId)
    } else {
      console.log('there is no parantObjId')
    }
    if (this.$route.params.item) {
      console.log(this.$route.params.item.relations)
      this.keyresultInfo.contentText = this.$route.params.item.contentText
      this.keyresultInfo.createdAt = this.$route.params.item.createdAt
      this.parentObjId = this.$route.params.item.parentObjId
      if (this.$route.params.item.limitedAccess) {
        if (this.$route.params.item.limitedAccess.limitedUsers) {
          this.checkedPublicUsers = Object.keys(this.$route.params.item.limitedAccess.limitedUsers)
        }
        if (this.$route.params.item.limitedAccess.limitedGroups) {
          let allGroups = this.getGroupsByIds(Object.keys(this.$route.params.item.limitedAccess.limitedGroups))
          let groupIds = Object.keys(allGroups).filter(x => !allGroups[x].isOrganization)
          let orgIds = Object.keys(allGroups).filter(x => allGroups[x].isOrganization)
          this.checkedPublicGroups = groupIds
          this.checkedPublicOrgs = orgIds
        }
      }
      if (this.$route.params.item.sharedOwners) {
        this.checkedShareUsers = Object.keys(this.$route.params.item.sharedOwners).filter(userId => userId !== this.uid)
      }
      if (this.$route.params.item.relations) {
        console.log(Object.values(this.$route.params.item.relations))
        this.checkedObjectives = Object.values(this.$route.params.item.relations).map(x => ({
          userId: x.userId,
          targetId: x.key,
          type: x.type
        }))
        console.log(this.checkedObjectives)
        this.oldRelationInfos = this.$route.params.item.relations
      }
    } else if (!this.isProxy && Object.keys(this.getCurrentDraftKeyresults).filter(x => !this.getCurrentDraftKeyresults[x] ? false : this.getCurrentDraftKeyresults[x].contentText).length > 0) {
      this.$swal({
        title: this.$t('comfirmMakeFromDraftStr'),
        type: 'question',
        showCancelButton: true,
        reverseButtons: false,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          this.checkDraft = true
          const CDKeyresults = this.getCurrentDraftKeyresults
          // console.log(CDObjective)
          for (let x of Object.keys(CDKeyresults)) {
            if (CDKeyresults[x].contentText) {
              console.log('true', CDKeyresults[x])
              this.keyresultInfo.contentText = CDKeyresults[x].contentText
              this.progress = CDKeyresults[x].progress
              this.dueDate = new Date(CDKeyresults[x].dueDate)
              if (CDKeyresults[x].limitedAccess) {
                if (CDKeyresults[x].limitedAccess.limitedUsers) {
                  this.checkedPublicUsers = Object.keys(CDKeyresults[x].limitedAccess.limitedUsers)
                }
                if (CDKeyresults[x].limitedAccess.limitedGroups) {
                  this.checkedPublicGroups = Object.keys(CDKeyresults[x].limitedAccess.limitedGroups)
                } else if (CDKeyresults[x].limitedAccess.limitedGroup) {
                  this.checkedPublicGroups = Object.keys(CDKeyresults[x].limitedAccess.limitedGroup)
                }
              }
              if (CDKeyresults[x].sharedOwners) {
                this.checkedShareUsers = Object.keys(CDKeyresults[x].sharedOwners).filter(userId => userId !== this.uid)
              }
              if (CDKeyresults[x].startDate) {
                this.startDate = new Date(CDKeyresults[x].startDate)
              }
              if (CDKeyresults[x].relations) {
                this.checkedObjectives = Object.values(CDKeyresults[x].relations).map(x => ({userId: x.userId, targetId: x.key, type: x.type}))
              }
            }
          }
        } else {
          console.log('false')
        }
      })
    }
  },
  methods: {
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    ...mapActions('keyResults/', {
      // VuexFireからのActionを読み込み
      setNewKeyresult: 'SET_NEW_KEYRESULT',
      setDraftsKeyresults: 'SET_DRAFTS_KEYRESULTS',
      removeDraftsKeyresults: 'REMOVE_DRAFTS_KEYRESULTS'
    }),
    onClickModalOk () {
      this.showModal = false
      this.checkedObjectives = this.checkedObjectives.concat(this.preCheckedObjs)
      this.preCheckedObjs = []
      console.log(this.checkedObjectives)
    },
    // public
    onClickGroups: function (value) {
      this.checkedPublicGroups = value
    },
    onClickOrg: function (value) {
      this.checkedPublicOrgs = value
    },
    onClickUsers: function (value) {
      this.checkedPublicUsers = value
    },
    // publicここまで
    isShowObjectives: function (objectiveId) {
      let checkedObjTargetIds = {}
      console.log('isShowObjectives', objectiveId)
      if (this.checkedObjectives.length !== 0) {
        for (let cobj in this.checkedObjectives) {
          checkedObjTargetIds.targetId = this.checkedObjectives[cobj].targetId
          console.log(checkedObjTargetIds.targetId)
          if (objectiveId === checkedObjTargetIds.targetId) {
            console.log('isShowObjectives: false')
            return false
          } else {
            console.log('isShowObjectives: true')
          }
        }
        return true
      } else {
        return true
      }
    },
    onClickUser: function (key, user) {
      let objectives = this.getObjectivesByUserId(key)
      let count
      let $t = this.$t
      if (Object.keys(objectives).length === 0) {
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('noObjective'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else {
        count = Object.keys(objectives).length
        for (let id in objectives) {
          // console.log('obj::', id, this.targetItemKey)
          if (objectives[id].isComplete) {
            count = count - 1
          } else if (id === this.parentObjId) {
            count = count - 1
          }
        }
        // console.log('count.length::', count, Object.keys(count).length)
        if (count > 0) {
          this.targetUserId = key
          this.targetUser = user
          this.showModal = true
        } else {
          this.$swal({
            title: $t('popTitleStrType'),
            text: $t('noObjective'),
            type: 'warning',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
        }
      }
    },
    closeModal () {
      this.showModal = false
    },
    getIsOpen: function (objectiveId) {
      return Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.keyresultOpen[objectiveId]
    },
    getIsComp: function (item) {
      return Object.keys(item).filter(x => x === 'isComplete').length === 0 ? false : item.isComplete
    },
    getTargetKeyresults (key) {
      // 算出プロパティだと引数がつけられないためmethodに
      return this.getKeyresultsByParentObjId(key)
    },
    resetSelectPublic: function () {
      this.checkedPublicUsers = []
      this.checkedPublicGroup = []
      this.checkedPublicOrgs = []
      this.$refs.publicSetting.resetCheckings()
    },
    deletePublicUser: function (userId) {
      let targetIndex = this.checkedPublicUsers.indexOf(userId)
      this.checkedPublicUsers.splice(targetIndex, 1)
    },
    deletePublicGroup: function (groupId) {
      let targetIndex = this.checkedPublicGroups.indexOf(groupId)
      this.checkedPublicGroups.splice(targetIndex, 1)
    },
    deletePublicOrg: function (orgId) {
      let targetIndex = this.checkedPublicOrgs.indexOf(orgId)
      this.checkedPublicOrgs.splice(targetIndex, 1)
    },
    setDetail (value) {
      console.log('parent methods clear')
      this.detail = value
      this.open = true
    },
    updateProgressInfo: function (value) {
      this.getRate = value
    },
    setKeyresultOpen: function (objectiveId) {
      Vue.set(this.keyresultOpen, objectiveId, Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? true : !this.keyresultOpen[objectiveId])
    },
    newKeyresult: function () {
      if (!this.parentObjId) {
        this.$swal({
          title: this.$t('popTitleStrType'),
          text: this.$t('invalidAccessByKeyResult'),
          type: 'warning',
          customClass: 'animated fadeInUp',
          width: '35rem',
          animation: false,
          position: 'center',
          timer: 5000,
          padding: '2rem'
        }).then((result) => {
          console.log('there is no parentObjId', result)
          this.$router.push('/okr/list')
        })
      }
      if (!this.$v.keyresultInfo.contentText.contentTextValidaiton) {
        this.$swal({
          title: this.$t('setupKeyResultGoal'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.dueDate || !this.startDate) {
        this.$swal({
          title: this.$t('noDayStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.$v.dueDate.dueDateValidation) {
        this.$swal({
          title: this.$t('alertDateStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else {
        this.isRegistering = true
        const keyresultId = this.id
        let removeDraft = this.removeDraftsKeyresults
        var ddt = this.dueDate
        var dstr = ddt.getFullYear() + '/' +
        ('0' + (ddt.getMonth() + 1)).slice(-2) + '/' +
        ('0' + ddt.getDate()).slice(-2)
        this.keyresultInfo.dueDate = dstr
        var sdt = this.startDate
        var sstr = sdt.getFullYear() + '/' +
          ('0' + (sdt.getMonth() + 1)).slice(-2) + '/' +
          ('0' + sdt.getDate()).slice(-2)
        this.keyresultInfo.startDate = sstr
        if (this.progress) {
          this.keyresultInfo.progress = String(Math.min(this.progressMax, Math.max(this.progressMin, this.progress)))
        } else {
          this.keyresultInfo.progress = '0'
        }
        this.keyresultInfo.parentObjId = this.parentObjId
        this.keyresultInfo.createdAt = this.$route.params.id ? this.keyresultInfo.createdAt : new Date().getTime() / 1000
        this.keyresultInfo.modifiedAt = new Date().getTime() / 1000
        if (this.checkedPublicUsers.length > 0) {
          this.keyresultInfo.limitedAccess.limitedUsers = this.parseArrayToObject(this.checkedPublicUsers)
        } else {
          this.keyresultInfo.limitedAccess.limitedUsers = null
        }
        if (this.checkedPublicGroups.length > 0 || this.checkedPublicOrgs.length > 0) {
          let Groups = this.checkedPublicGroups
          if (this.checkedPublicOrgs.length > 0) {
            Groups = Groups.concat(this.checkedPublicOrgs)
          }
          this.keyresultInfo.limitedAccess.limitedGroups = this.parseArrayToObject(Groups)
        } else {
          this.keyresultInfo.limitedAccess.limitedGroups = null
        }
        if (this.checkedShareUsers.length > 0) {
          this.checkedShareUsers.push(this.uid)
          this.keyresultInfo.sharedOwners = this.parseArrayToObject(this.checkedShareUsers)
        }
        let existingKeys = Object.values(this.oldRelationInfos).map(x => x.key)
        const value = {
          'keyresultInfo': this.keyresultInfo,
          'relationInfo': this.getRelationInfo(this.checkedObjectives.filter(x => !existingKeys.includes(x.targetId)), this.getUsersByIds(this.checkedObjectives.map(x => x['userId'])))
        }
        value.keyresultInfo.relations = {}
        for (let key in this.oldRelationInfos) {
          if (this.checkedObjectives.map(x => x.targetId).filter(x => x === this.oldRelationInfos[key].key).length > 0) {
            value.keyresultInfo.relations[key] = this.oldRelationInfos[key]
          }
        }
        console.log('value.objectiveInfo:::', value.keyresultInfo)
        let data = {
          okr: value.keyresultInfo,
          userId: this.getUserId
        }
        const validateRelationOKR = this.$firebase.functions().httpsCallable('validateRelationOKR')
        validateRelationOKR(data)
          .then(result => {
            console.log('validate relations result:::', result)
            const $t = this.$t
            if (result.data.status) {
              // エラーになったよ
              let message = result.data.text.replace(/\r?\n/g, '<br>')
              this.$swal({
                title: $t('popTitleStrType'),
                html: message,
                type: 'warning',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '70vw',
                position: 'center',
                padding: '2rem'
              }).then((result) => {
                this.isRegistering = false
                if (result.value) {
                  // OK押したよ
                  return { result: false }
                } else {
                  // OKおしてないよ
                  return { result: false }
                }
              })
            } else {
              // 登録できるよ
              return { result: true }
            }
          })
          .then(swalResult => {
            if (swalResult) {
              if (this.isProxy) {
                const proxyOKRinLieuOfUser = this.$firebase.functions().httpsCallable('proxyOKRinLieuOfUser')
                const proxyValue = {
                  'targetUserId': this.uid,
                  'targetItemType': 'keyresults',
                  'targetItemId': '',
                  'targetValue': value
                }
                if (!keyresultId) {
                  proxyOKRinLieuOfUser(proxyValue).then(() => {
                    this.$router.push({ name: 'ProxyOkr', params: {targetUser: this.uid} })
                  })
                } else {
                  proxyValue.targetItemId = keyresultId
                  proxyOKRinLieuOfUser(proxyValue).then(() => {
                    this.$router.push({ name: 'ProxyOkr', params: {targetUser: this.uid} })
                  })
                }
                this.$router.push({ name: 'ProxyOkr', params: {targetUser: this.uid} })
              } else {
                if (!keyresultId) {
                  this.setNewKeyresult(value)
                  if (this.checkDraft) {
                    removeDraft(this.getUserId)
                    this.checkDraft = false
                  }
                } else {
                  value.keyresultId = keyresultId
                  this.setNewKeyresult(value)
                }
                /* add relation and limited users to visited user list start */
                for (let checkedObjective of this.checkedObjectives) {
                  this.setVisit(checkedObjective.userId)
                }
                /* add relation and limited users to visited user list end */

                this.$router.push('/okr/list')
              }
            }
          })
      }
    },
    cancelKeyresult: function () {
      const $t = this.$t
      if (this.parentObjId) {
        if (this.$v.keyresultInfo.contentText.contentTextValidaiton && this.$v.dueDate.dueDateValidation) {
          var ddt = this.dueDate
          var dstr = ddt.getFullYear() + '/' +
            ('0' + (ddt.getMonth() + 1)).slice(-2) + '/' +
            ('0' + ddt.getDate()).slice(-2)
          this.keyresultInfo.dueDate = dstr
          var sdt = this.startDate
          var sstr = sdt.getFullYear() + '/' +
            ('0' + (sdt.getMonth() + 1)).slice(-2) + '/' +
            ('0' + sdt.getDate()).slice(-2)
          this.keyresultInfo.startDate = sstr
          this.keyresultInfo.progress = this.progress
          this.keyresultInfo.createdAt = new Date().getTime() / 1000
          if (this.checkedPublicUsers.length > 0) {
            this.keyresultInfo.limitedAccess.limitedUsers = this.parseArrayToObject(this.checkedPublicUsers)
          }
          if (this.checkedPublicGroups.length > 0) {
            this.keyresultInfo.limitedAccess.limitedGroups = this.parseArrayToObject(this.checkedPublicGroups)
          }
          if (this.checkedShareUsers.length > 0) {
            this.checkedShareUsers.push(this.getUserId)
            this.keyresultInfo.sharedOwners = this.parseArrayToObject(this.checkedShareUsers)
          }
          const value = {
            'keyresultInfo': this.keyresultInfo,
            'relationInfo': this.getRelationInfo(this.checkedObjectives, this.getUsersByIds(this.checkedObjectives.map(x => x['userId'])))
          }
          if (Object.keys(this.getCurrentDraftKeyresults).filter(x => !this.getCurrentDraftKeyresults[x] ? false : this.getCurrentDraftKeyresults[x].contentText).length > 0) {
            this.$swal({
              title: $t('popTitleStrType'),
              text: $t('popMessageStr2Type'),
              showCancelButton: true,
              cancelButtonColor: '#f64846',
              type: 'warning',
              confirmButtonClass: 'btn btn-success',
              cancelButtonClass: 'btn btn-danger',
              reverseButtons: false,
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              allowOutsideClick: false,
              padding: '2rem'
              // timer: 5000
            }).then((result) => {
              if (result.value) {
                console.log('true')
                this.setDraftsKeyresults(value)
                this.$swal({
                  title: this.$t('compStorageStr'),
                  type: 'success',
                  animation: false,
                  customClass: 'animated fadeInUp',
                  // customClass: 'animated flipInX',
                  width: '35rem',
                  position: 'center',
                  // toast: true,
                  padding: '2rem',
                  timer: 3000
                })
                this.$router.push('/okr/list')
              } else {
                console.log('false')
                this.$router.push('/okr/keyresult-regist')
              }
            })
          } else {
            this.$swal({
              title: this.$t('compStorageStr'),
              type: 'success',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
            this.setDraftsKeyresults(value)
            this.$router.push('/okr/list')
          }
        } else if (!this.$v.keyresultInfo.contentText.contentTextValidaiton) {
          this.$swal({
            title: this.$t('setupKeyResultGoal'),
            type: 'warning',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
        } else if (!this.$v.dueDate.dueDateValidation) {
          this.$swal({
            title: this.$t('alertDateStr'),
            type: 'warning',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
        }
      } else {
        this.$swal({
          title: this.$t('popTitleStrType'),
          text: this.$t('invalidAccessByKeyResult'),
          type: 'warning',
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          animation: false,
          // toast: true,
          padding: '2rem',
          timer: 3000
        }).then((result) => {
          this.$router.push('/okr/list')
          console.log('there is no parentObjId', result)
        })
      }
    },
    deleteRelation: function (id, type) {
      this.checkedObjectives = this.checkedObjectives.filter(x => !(x.type === type && x.targetId === id))
    },
    parseArrayToObject: function (array) {
      let obj = {}
      for (const i in array) {
        obj[array[i]] = 1
      }
      return obj
    },
    onClickCancel: function () {
      const $t = this.$t
      this.$swal({
        title: $t('popTitleStrType'),
        text: $t('confirmInputDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          if (this.isProxy) {
            this.$router.push({ name: 'ProxyOkr', params: {targetUser: this.uid} })
          } else {
            this.$router.push('/okr/list')
          }
        } else {
          console.log('false')
        }
      })
    },
    checkRelationsFillter: function (obj, objectiveId) {
      if (obj.contentText && !obj.isComplete && this.parentObjId !== objectiveId) return true
      else return false
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal {
    position: absolute;
    top: 10%;
    display: block;
    width: 80%;
    height: auto;
    margin: 0 auto;
    opacity: 1.0;
    overflow: visible;
}
  .modal-wrapper{
    height: 100vh;
    display: table-cell;
    vertical-align: middle;
  }
  /* .ibox-child.add-key { height: 80px; }*/
  .keyResultClose .ibox-child {
    height: 0;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
    overflow:  hidden;
    border: none;
  }
  .fa-chevron-down{
    transition: all 0.2s ease-in-out;
  }
  .chevronUp{
    transform: rotate(180deg);
  }
  .added:after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-color: #445;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/views/okr/KeyresultRegist.vue